import io from "socket.io-client";
import { ASSESSMENT_URL } from "../../utils/url-builder";
import { showLoader, hideLoader } from "../actions/loader.action";
import { showError } from "../actions/error.action";

export class BaseEvent {
  constructor(store) {
    BaseEvent.store = store;
    BaseEvent.isLoading = false;
  }


  static showLoader(showNormalLoader = true) {
    if (BaseEvent.isLoading) return;

    BaseEvent.isLoading = true;
    BaseEvent.store.dispatch(showLoader("Loading..."));
  }

  static hideLoader() {
    if (!BaseEvent.isLoading) return;

    BaseEvent.isLoading = false;

    BaseEvent.store.dispatch(hideLoader());
  }

  static showError(error) {
    BaseEvent.store.dispatch(showError(error));
  }

  async dispatchAction(action) {
    await BaseEvent.store.dispatch(action);
  }
}

// BaseEvent.init();
